// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"TakeoverHeader__srOnly--4jLRg","hiddenInput":"TakeoverHeader__hiddenInput--37lnO","root":"TakeoverHeader__root--2FlyS"};